import classNames from 'helpers/class-names'
import NextLink from 'next/link'
import { FC, ReactNode } from 'react'

type LinkProps = {
  children: ReactNode
  href: string
  className?: string
  dataCy?: string
  target?: string
  rel?: string
}
export const Link: FC<LinkProps> = ({
  children,
  href,
  className,
  dataCy = '',
  target = '_self',
  rel = '',
}) => {
  return (
    <NextLink href={href}>
      <a
        className={classNames(
          'text-info underline-offset-1 hover:underline',
          className,
        )}
        target={target}
        rel={rel}
        data-cy={dataCy}>
        {children}
      </a>
    </NextLink>
  )
}
